<app-grafana-embed
  [src]="grafanaMaritime"
  [height]="900"
></app-grafana-embed>
